import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Tooltip, IconButton } from '@material-ui/core';
import { LinkOff as LinkOffIcon, RemoveRedEye as ViewIcon, People as PeopleIcon } from '@material-ui/icons';
import { FHETable, DetailPanelUsers } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { dissociateSDM18HCLUser, dissociateSDM18HCLUserAndSwitchMaster } from '../../../data/SDM18HCL/actions';

class TableSDM18HCL extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        dissociateSDM18HCLUser: PropTypes.func.isRequired,
        dissociateSDM18HCLUserAndSwitchMaster: PropTypes.func.isRequired,
        SDM18HCLs: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        userId: PropTypes.number.isRequired,
        profile: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            dissociateLoading: null
        };
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/${history.environment}/SDM18HCL/detail/${rowData.id}` });
    };

    navigateToUser = event => {
        const { history } = this.props;
        return history.push({
            pathname: `/${history.environment}/user/detail/${event.currentTarget.getAttribute('data-userid')}`
        });
    };

    /* ACTIONS */
    dissociateUser = SDM18HCLMac => {
        const { dissociateSDM18HCLUser, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM18HCLMac });

        dissociateSDM18HCLUser(SDM18HCLMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM18HCL.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM18HCL.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMaster = SDM18HCLMac => {
        const { dissociateSDM18HCLUser, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM18HCLMac });

        dissociateSDM18HCLUser(SDM18HCLMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM18HCL.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM18HCL.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMasterAndSwitch = (SDM18HCLMac, newMasterId) => {
        const { dissociateSDM18HCLUserAndSwitchMaster, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM18HCLMac });

        dissociateSDM18HCLUserAndSwitchMaster(SDM18HCLMac, userId, newMasterId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM18HCL.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM18HCL.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateProduct = rowData => {
        const { dissociateLoading } = this.state;
        const { userId, history } = this.props;
        if (dissociateLoading === rowData.id) return false;
        if (rowData.otherUsers.length === 0 && rowData.userMasterId === userId) {
            Toastr.confirm(
                Translator.translate(`general.products.SDM18HCL.table.action.dissociate.confirmRemoveMasterAlone`, rowData.macAddress),
                Translator.translate(`general.products.SDM18HCL.table.action.dissociate.confirmRemoveMasterTitle`),
                {
                    onYes: () => {
                        this.dissociateMaster(rowData.id);
                    }
                }
            );
        } else if (rowData.userMasterId === userId) {
            Toastr.select(
                Translator.translate(`general.products.SDM18HCL.table.action.dissociate.confirmRemoveMaster`, rowData.macAddress),
                Translator.translate(`general.products.SDM18HCL.table.action.dissociate.confirmRemoveMasterTitle`),
                rowData.otherUsers,
                {
                    onYes: newMasterId => {
                        this.dissociateMasterAndSwitch(rowData.id, parseInt(newMasterId));
                    }
                }
            );
        } else {
            Toastr.confirm(
                Translator.translate(`general.products.SDM18HCL.table.action.dissociate.confirmRemove`, rowData.macAddress),
                Translator.translate(`general.products.SDM18HCL.table.action.dissociate.confirmRemoveTitle`),
                {
                    onYes: () => {
                        this.dissociateUser(rowData.id);
                    }
                }
            );
        }
    };

    /* RENDER */
    renderData = memoizeOne(SDM18HCLs => {
        let result = [];

        SDM18HCLs.map(SDM18HCL => {
            result.push({
                id: SDM18HCL.get('macAddress'),
                macAddress: SDM18HCL.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                addressIp: SDM18HCL.get('addressIp'),
                email: SDM18HCL.get('userEmail'),
                label: SDM18HCL.get('label'),
                state: SDM18HCL.getIn(['state'], false) ? Translator.translate(`general.${SDM18HCL.get('state')}`) : null,
                firmwareVersion: SDM18HCL.get('firmwareVersion'),
                usersList: SDM18HCL.get('usersList'),
                otherUsers: SDM18HCL.get('otherUsers'),
                userMasterId: SDM18HCL.get('userMasterId')
            });
        });
        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [
                {
                    icon: LinkOffIcon,
                    onClick: this.dissociateProduct,
                    tooltip: Translator.translate(`general.products.SDM18HCL.table.action.dissociate.tooltip`)
                }
            ],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('SDM18HCLDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderDetails = memoizeOne(() => {
        return {
            renderToggleCell: ({ row, onToggle }) => {
                return (
                    <Tooltip title={Translator.translate('general.table.button.showUserList')} disableHoverListener={!row.userMasterId}>
                        <span>
                            <IconButton onClick={onToggle} disabled={!row.userMasterId}>
                                <PeopleIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
            renderPanel: ({ row }) => {
                return <DetailPanelUsers usersList={row.usersList} userMasterId={row.userMasterId} onClick={this.navigateToUser} />;
            }
        };
    });

    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('SDM18HCLDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.addressIp'),
                name: 'addressIp'
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            }
        ];
    });

    renderSDM18HCL() {
        const { SDM18HCLs, profile } = this.props;

        return (
            <FHETable
                idTable="userDetailSDM18HCL"
                columns={this.renderColumns(profile)}
                data={this.renderData(SDM18HCLs)}
                actions={this.renderActions(profile)}
                rowDetail={this.renderDetails()}
                minified
            />
        );
    }

    render() {
        const { SDM18HCLs, history } = this.props;
        return (
            <Fragment>
                {SDM18HCLs.size > 0 ? this.renderSDM18HCL() : Translator.translate(`general.products.SDM18HCL.table.body.emptyDataSourceMessage`)}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const userId = props.match.params.userId;
    const users = state.environments[history.environment].data.Users.get('list');
    const actualUser = users.getIn([userId], new Map());
    let SDM18HCLs = state.environments[history.environment].data.SDM18HCL.get('list')
        .filter(SDM18HCL => {
            return SDM18HCL.getIn(['usersList'], []).indexOf(parseInt(userId)) !== -1;
        })
        .map(SDM18HCL => {
            const masterUser = users.getIn([SDM18HCL.getIn(['userMasterId'], '').toString()], new Map());
            let otherUsers = [];
            const usersList = SDM18HCL.getIn(['usersList'], [])
                .map(_userId => {
                    const _user = users.getIn([_userId.toString()], new Map());
                    if (parseInt(userId) !== _user.get('_id'))
                        otherUsers.push({ id: _user.get('_id'), label: `${_user.get('firstname')} ${_user.get('lastname')}` });
                    return _user;
                })
                .sort(a => {
                    if (a.get('_id') === SDM18HCL.get('userMasterId')) return -1;
                    else return 1;
                });
            return SDM18HCL.set('userEmail', masterUser.get('email'))
                .set('usersList', usersList)
                .set('otherUsers', otherUsers);
        });
    return {
        profile: state.data.user,
        user: actualUser,
        users,
        SDM18HCLs
    };
}

const styles = theme => ({
    detailPanelHeader: {
        color: theme.palette.text.secondary
    },
    masterRow: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.dark
    },
    userRow: {
        backgroundColor: 'white',
        color: theme.palette.text.secondary
    },
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { dissociateSDM18HCLUser, dissociateSDM18HCLUserAndSwitchMaster }), dispatch)
    )(withStyles(styles, { withTheme: true })(TableSDM18HCL))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/Table/TableSDM18HCL.js